import React from 'react';
import ReactDOM from 'react-dom/client';
import { loader } from '@monaco-editor/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Load Monaco from our app origin to avoid CDN load failures (CORS, network, corporate proxy).
// Run `npm run copy-monaco` after install so public/vs is populated.
loader.config({ paths: { vs: '/vs' } });

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
